import React, { Component } from 'react';
import { getAPI } from '../../Base/API';
import { FormatAmountNumber, StyledCard, formatAmountNumberString, FilterButton } from '../../Base/Common/CommonUIComponents';
import { CustomTable } from '../../Base/Common/CustomTable';
import { CheckAuthorization } from '../../Base/Authorization';
import { FormattedMessage, injectIntl, FormattedHTMLMessage } from "react-intl";
import { handleNotification } from '../../Base/Common/Notification';
import { getRightVoucherId, getStatus } from '../../Base/Common/ReferenceDataFunctions';
import CustomSelect from '../../Base/Common/CustomSelect';
import { Col, Form, Row, Button, Input } from 'reactstrap';
import { DateRangePicker } from 'react-dates';
import ExcelJS from 'exceljs';
import moment from 'moment';


class UsageReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            block: false,
            fromDate: moment().subtract(365, 'days'),
            toDate: moment(),
            hotelList: [],
            hotelId: null,
            isExpired: null,
            email: null,
            voucherStatusOptions: [
                { value: true, label: <FormattedMessage id="UsageReport.ExpiredVouchers" /> },
                { value: false, label: <FormattedMessage id="UsageReport.ValidVouchers" /> },
            ],
            pageIndex: 1,
            pageSize: 10
        }
    }

    componentDidMount() {
        this.updateStateFilters();
        this.getVoucherType();
        this.getHotels();
    }
    
    updateStateFilters = () => {
        let params = new URLSearchParams(window.location.search);
        
        if (!params.has('page')) params.append('page', 1);

        this.props.history.push({ search: `?${params}` });


        let pageIndex = params.get('page') || 1;
        let hotelId = params.get('hotelId');
        let voucherType = params.getAll('voucherType');
        let isExpired = params.get('isExpired');
        let status = params.getAll('status');
        let fromDate = params.get('fromDate') ?? this.state.fromDate;
        let toDate = params.get('toDate') ?? this.state.toDate;
        let email = params.get('email') ?? this.state.email;

        this.setState({
            pageIndex, hotelId,
            voucherType: voucherType ?? [],
            isExpired,
            status: status ?? [],
            fromDate, toDate,
            email
        },() => this.getUsageReport());
    }    

    updateAndGetUrlParams = (updateUrlParams) => {
        const { pageIndex, hotelId, voucherType, isExpired, status, fromDate, toDate, email } = this.state;
        
        if (updateUrlParams) {
            let url = `fromDate=${moment(fromDate).format("YYYY-MM-DD")}&toDate=${moment(toDate).format("YYYY-MM-DD")}&page=${pageIndex}`;

            if (hotelId) url += `&hotelId=${hotelId}`;
            if (voucherType) voucherType.forEach(type => { url += `&voucherType=${type}` });
            if (isExpired !== null) url += `&isExpired=${isExpired}`;
            if (status) status.forEach(type => { url += `&status=${type}` });
            if (email) url += `&email=${email}`;
            
            this.props.history.push({ search: url });
        }

        var params = `?fromDate=${moment(fromDate).format("YYYY-MM-DD")}&toDate=${moment(toDate).format("YYYY-MM-DD")}`;

        if (hotelId) params += `&hotelId=${hotelId}`;
        if (voucherType) voucherType.forEach(type => { params += `&voucherType=${type}` });
        if (isExpired !== null) params += `&isExpired=${isExpired}`;
        if (status) status.forEach(type => { params += `&status=${type}` });
        if (email) params += `&email=${email}`;

        return params;
    }

    getUsageReport = (e, updateUrlParams) => {
        if (e) e.preventDefault();

        this.setState({ block: true });

        var params = this.updateAndGetUrlParams(updateUrlParams)

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                if (data.response) {
                    this.setState({ usageReport: data.response });
                }
            }
            this.setState({ error: errorMessage, block: false });
        }, `/api/Voucher/Voucher/v1/usageReport` + params);
    }

    getVoucherType = () => {
        this.setState({ blockVoucherType: true });

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockVoucherType: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                if (data.response && data.response.length > 0) {
                    let arr = data.response.map((el) => ({ value: el.id, label: el.code }));

                    this.setState({ voucherConfigList: arr, error: errorMessage, blockVoucherType: false });
                    return;
                }

                this.setState({ error: errorMessage, blockVoucherType: false });
            }
            else this.setState({ error: errorMessage, blockVoucherType: false });
        }, '/api/Voucher/V1/Config?isPayment=true');
    }
    
    getHotels = () => {
        this.setState({ blockHotels: true });
        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockHotels: false });

                return;
            }
            if (data) {
                const hotelList = data.response[0].hotels?.map((el) => ({ value: el.hotelId, label: el.name2 })) || [];

                this.setState({ hotelList, blockHotels: false });
            }
            else
                this.setState({ error: errorMessage, blockHotels: false });
        }, '/api/Voucher/Hotel/v1/hotel');

    }

    downloadExcel = async () => {
        const { usageReport, hotelList } = this.state;
        
        if (!usageReport || usageReport.length === 0) {
            handleNotification({
                errors: [{
                    message: this.props.intl.formatMessage({ id: "generic.table.nodata" }),
                    type: 'warning'
                }]
            });
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Usage Report');

        const visibleColumns = getColumns(hotelList, this.props.intl).filter(col => !col.hidden);
        
        worksheet.columns = visibleColumns.map(col => ({
            header: col.text,
            key: col.dataField,
            width: 20
        }));

        // Style header row
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getRow(1).height = 30;
        worksheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' }
        };

        // Add data rows
        usageReport.forEach(row => {
            const rowData = {};

            visibleColumns.forEach(col => {
                const cellValue = row[col.dataField];
                
                rowData[col.dataField] = col.csvFormatter ? col.csvFormatter(cellValue, row) : (cellValue || '');
            });

            const addedRow = worksheet.addRow(rowData);
            addedRow.height = 25; 
            addedRow.alignment = { vertical: 'middle' };
        });

        // Generate file and download
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `UsageReport_${moment().format('YYYY-MM-DD_HH:mm')}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        } 
        catch (error) {
            console.error('Error generating Excel file:', error);
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSelect = (name, combo) => {
        this.setState({
            [name]: combo ? combo.value : null
        })
    }

    handleMultiCombo = (combo, name) => {
        this.setState({
            [name]: combo ? combo.map(el => el.value) : null
        })
    }

    handleTableChange = (type, { page }) => {
        this.setState({
            pageIndex: page,
        }, () => {
            const params = new URLSearchParams(this.props.location.search);
            params.set('page', page);
            this.props.history.replace({ search: `?${params}` });
        });
    }

    doSearch = (e) => {
        e.preventDefault();
        this.setState({ pageIndex: 1 }, () => this.getUsageReport(e, true));
    }

    countFilters = () => {
        const { fromDate, toDate, hotelId, voucherType, isExpired, status, email } = this.state;
        let count = 0;
        
        if (fromDate || toDate) count++;
        if (hotelId) count++;
        if (voucherType) count++;
        if (typeof isExpired === 'boolean') count++;
        if (status?.length > 0) count++;
        if (email) count++;

        return count;
    }

    render() {
        const { block, error, usageReport, fromDate, toDate, hotelList, hotelId,pageIndex, pageSize } = this.state;

        
        const canViewRestricted = CheckAuthorization('adminRestrictedVoucher:view');
        const restrictedRowIds = (this.state.usageReport || [])
            .filter(v => v.adminRestricted && !canViewRestricted)
            .map(v => v.id);

        const rowStyle = (row) => row.adminRestricted && !canViewRestricted ?
            { cursor: 'default', opacity: 0.55 } : { cursor: 'pointer' };

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,
            nonSelectable: restrictedRowIds,

            onSelect: (row, isSelect, rowIndex, e) => {
                if (row.adminRestricted && !canViewRestricted) return;
                this.props.history.push('/VoucherOperationDetails/'+row.id)
            }
        };


        return (
            <StyledCard icon={'fa-solid fa-file-lines'} title={'navbar.UsageReport'} error={error} block={block} id="usageReportHelp" help={<FormattedHTMLMessage id="UsageReport.Help" />}>
                <Form onSubmit={this.doSearch}>
                    <Row className="mb-3">
                        <Col sm={3}>
                            <CustomSelect
                                icon="fa-solid fa-hotel"
                                options={hotelList}
                                isClearable
                                isSearchable
                                placeholder={<FormattedMessage id="generic.Hotel" />}
                                value={hotelList.find(el => el.value === hotelId) || ''}
                                onChange={(combo) => this.handleSelect('hotelId', combo)}
                                isLoading={this.state.blockHotels}
                            />
                        </Col>
                        <Col className="col-3">
                            <CustomSelect
                                options={this.state.voucherConfigList}
                                isClearable
                                isMulti
                                name="voucherType"
                                onChange={(e) => this.handleMultiCombo(e, 'voucherType')}
                                placeholder={<FormattedMessage id="OperationManagement.CardType" />}
                                isLoading={this.state.blockVoucherType}
                                value={this.state.voucherType ? this.state.voucherConfigList?.filter(el => this.state.voucherType.map(String).includes(el.value.toString())) : ''}
                            />
                        </Col>
                        <Col className="col-3">
                            <CustomSelect
                                options={getStatus(true)}
                                isClearable
                                isMulti
                                value={this.state.status ? getStatus(true).filter(el => this.state.status.includes(el.value)) : ''}
                                name="status"
                                onChange={(e) => this.handleMultiCombo(e, "status")}
                                placeholder={<FormattedMessage id="OperationManagement.Status" />}
                            />
                        </Col>
                        <Col className="text-right">
                            <span className="mr-2 pr-1">
                                <FilterButton totalFilters={this.countFilters()} >
                                    <div >
                                        <div>
                                            <div className='title-sm' style={{ fontSize: '0.9em' }}>
                                                <i className="far fa-calendar-check mr-1" />
                                                <FormattedMessage id="VoucherOperationDetails.CreatedAt" />
                                            </div>
                                            <div>
                                                <DateRangePicker
                                                    startDateId="vouchersValidFrom"
                                                    startDate={fromDate ? moment(fromDate) : null}
                                                    isOutsideRange={day => day > moment().endOf('day')}
                                                    endDate={toDate ? moment(toDate) : null}
                                                    endDateId="vouchersValidUntil"
                                                    onDatesChange={({ startDate, endDate }) => this.setState({ fromDate: startDate, toDate: endDate })}
                                                    focusedInput={this.state.focusedInput}
                                                    onFocusChange={focusedInput => this.setState({ focusedInput })}
                                                    small={true}
                                                    required
                                                    numberOfMonths={1}
                                                    showDefaultInputIcon={true}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className='title-sm mt-3' style={{ fontSize: '0.9em' }}>
                                                <i className="fas fa-clipboard-list mr-1" />
                                                <FormattedMessage id="VoucherOperationDetails.Vality" />
                                            </div>
                                            <div>
                                                <CustomSelect
                                                    options={this.state.voucherStatusOptions}
                                                    isClearable
                                                    name="isExpired"
                                                    onChange={(e) => this.handleSelect('isExpired', e)}
                                                    placeholder={<FormattedMessage id="VoucherOperationDetails.Vality" />}
                                                    value={this.state.isExpired !== null ? this.state.voucherStatusOptions.find(el => el.value.toString() === this.state.isExpired.toString()) : ''}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className='title-sm mt-3' style={{ fontSize: '0.9em' }}>
                                                <i className="fas fa-at mr-1" />
                                                <FormattedMessage id="generic.Email" />
                                            </div>
                                            <div>
                                                <Input
                                                    type="text"
                                                    placeholder={this.props.intl.formatMessage({ id: "generic.Email" })}
                                                    value={this.state.email || ''}
                                                    name="email"
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </FilterButton>
                            </span>    
                            <Button className="btn btn-host btn-sm ml-3" type="submit">
                                <i className="fa-solid fa-magnifying-glass" />
                            </Button>
                        </Col>
                    </Row>
                </Form>
                
                <Button id='export-to-excel-button-grid' className="btn btn-host btn-sm float-right mb-2" onClick={this.downloadExcel}>
                    <i className="fa-solid fa-file-arrow-down" />
                </Button>
                <CustomTable
                    data={(usageReport || []).slice((pageIndex - 1) * pageSize, pageIndex * pageSize)}
                    columns={getColumns(hotelList, this.props.intl)}
                    showTotal={true}
                    selectRow={selectRow}
                    rowStyle={rowStyle}
                    page={parseInt(pageIndex) || 1}
                    sizePerPage={parseInt(pageSize) || 10}
                    totalSize={(usageReport || []).length}
                    onTableChange={this.handleTableChange}
                    remote={{ pagination: true }}
                />
            </StyledCard>
        );
    }
}

export default injectIntl(UsageReport);


const getColumns = (hotelList, intl) => [
    {
        dataField: 'voucherId',
        text: intl.formatMessage({ id: "OperationManagement.CardId" }),
        sort: true,
        formatter: (cell, row) => getRightVoucherId(cell, row.voucherIdFirst8),
        csvFormatter: (cell, row) => getRightVoucherId(cell, row.voucherIdFirst8)
    },
    {
        dataField: 'createdAt',
        text: intl.formatMessage({ id: "OperationManagement.IssueDate" }),
        sort: true,
        formatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD") : null,
        csvFormatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD") : null
    },
    {
        dataField: 'createdBy',
        text: intl.formatMessage({ id: "OperationManagement.IssuedBy" }),
        sort: true
    },
    {
        dataField: 'voucherTypeCode',
        text: intl.formatMessage({ id: "OperationManagement.CardType" }),
        sort: true
    },
    {
        dataField: 'name',
        text: intl.formatMessage({ id: "VoucherOperationDetails.Name" }),
        sort: true,
        formatter: (cell) => cell ? cell : '',
        csvFormatter: (cell) => cell ? cell : ''
    },
    {
        dataField: 'email',
        text: intl.formatMessage({ id: "generic.Email" }),
        sort: true
    },
    {
        dataField: 'hotelId',
        text: intl.formatMessage({ id: "VoucherOperationDetails.Hotel" }),
        sort: true,
        formatter: (cell) => cell ? hotelList.find(el => el.value === cell)?.label || cell : '',
        csvFormatter: (cell) => cell ? hotelList.find(el => el.value === cell)?.label || cell : ''
    },
    {
        dataField: 'invoiceReference',
        text: intl.formatMessage({ id: "VoucherOperationDetails.InvoiceReference" }),
        sort: true
    },
    {
        dataField: 'validUntil',
        text: intl.formatMessage({ id: "VoucherOperationDetails.Vality" }),
        sort: true,
        formatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD") : '',
        csvFormatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD") : ''
    },
    {
        dataField: 'status',
        text: intl.formatMessage({ id: "VoucherOperationDetails.Status" }),
        sort: true,
        formatter: (cell) => intl.formatMessage({ id: `ReferenceDataFunctions.${cell}` }),
        csvFormatter: (cell) => intl.formatMessage({ id: `ReferenceDataFunctions.${cell}` }),
    },
    {
        dataField: 'saleAmount',
        text: intl.formatMessage({ id: "VoucherOperationDetails.PayedAmount" }),
        sort: true,
        formatter: (cell) => cell ? <FormatAmountNumber value={cell} /> : '',
        csvFormatter: (cell) => cell ? formatAmountNumberString(cell, intl) : ''
    },
    {
        dataField: 'voucherAmount',
        text: intl.formatMessage({ id: "VoucherOperationDetails.VoucherAmount" }),
        sort: true,
        formatter: (cell) => cell ? <FormatAmountNumber value={cell} /> : '',
        csvFormatter: (cell) => cell ? formatAmountNumberString(cell, intl) : ''
    },
    {
        dataField: 'redeemsAmount',
        text: intl.formatMessage({ id: "VoucherOperationDetails.Redeems" }),
        sort: true,
        formatter: (cell) => cell ? <FormatAmountNumber value={cell} /> : '',
        csvFormatter: (cell) => cell ? formatAmountNumberString(cell, intl) : ''
    },
    {
        dataField: 'availableBalance',
        text: intl.formatMessage({ id: "VoucherOperationDetails.AvailableBalance" }),
        sort: true,
        formatter: (cell) => cell ? <FormatAmountNumber value={cell} /> : '',
        csvFormatter: (cell) => cell ? formatAmountNumberString(cell, intl) : ''
    },
    {
        dataField: 'rfId',
        text: intl.formatMessage({ id: "VoucherOperationDetails.RfId" }),
        sort: true,
        formatter: (cell) => cell ? cell : '',
        csvFormatter: (cell) => cell ? cell : '',
        hidden: !global.modules?.some(m => m === "VoucherRFID")
    }
];